export default "__VITE_ASSET__BT1Xy_b2__"